export const crunchbaseConstants = {
  CRUNCHBASE_LIST_ORGANIZATIONS_LOADING: 'CRUNCHBASE_LIST_ORGANIZATIONS_LOADING',
  CRUNCHBASE_LIST_ORGANIZATIONS_SUCCESS: 'CRUNCHBASE_LIST_ORGANIZATIONS_SUCCESS',
  CRUNCHBASE_LIST_ORGANIZATIONS_FAILURE: 'CRUNCHBASE_LIST_ORGANIZATIONS_FAILURE'
};
